import { notification } from 'antd';
import http from 'utils/http';

export const getAllBinDiscounts = async (storeId, params) => {
  try {
    const response = await http.get(`/bin/${storeId}`, { params });
    return response?.data;
  } catch (err) {
    notification.error({ message: err?.response?.data?.message || 'NETWORK ERROR', placement: 'bottomRight' });
  }
};

export const addBinDiscount = async (storeId, payload) => {
  try {
    const response = await http.post(`/bin/config/create/${storeId}`, payload);
    notification.success({ message: 'BIN Discount Added',description:'BIN discount has been added successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};
export const addBinDiscountByCSVFile = async (storeId, payload) => {
  try {
    const response = await http.post(`/bin/config/csv/${storeId}`, payload);
    return response;
  } catch (err) {
    throw err;
  }
};
export const deleteBinDiscount = async (storeId, id) => {
  try {
    const response = await http.delete(`/bin/config/${storeId}/${id}`);
    notification.success({ message: 'BIN Discount Deleted',description: 'BIN discount has been deleted successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};

export const updateBinDiscount = async (storeId, id, payload) => {
  try {
    const response = await http.put(`/bin/config/${storeId}/${id}`, payload);
    notification.success({ message: 'BIN Discount Updated', description: 'BIN discount information has been updated successfully.', placement: 'bottomRight' });
    return response;
  } catch (err) {
    notification.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
  }
};
